import React from 'react';
import { VerticallyCenteredText } from '../VerticallyCenteredText';
import { Container, TabContainer } from './styles';
import { InternalTabProps, TabsProps, TabsWithContentProps } from './types';

const Tab = ({ activeTab, label, name, onChange }: InternalTabProps) => (
  <TabContainer active={activeTab === name} onClick={() => onChange(name)}>
    <VerticallyCenteredText>{label}</VerticallyCenteredText>
  </TabContainer>
);

/**
 * Alternative Tabs component that renders content of the current activeTab.
 */
export const TabsWithContent: React.FC<TabsWithContentProps> = (props) => {
  const { activeTab, className, onChange, tabs } = props;
  let contentToShow: IMPLICIT_ANY = null;

  return (
    <>
      <Container className={className}>
        {tabs.map((tab, index) => {
          const { label, name, renderContent } = tab;
          if (activeTab === name) {
            contentToShow = renderContent();
          }
          return (
            <Tab
              name={name}
              label={label || name}
              onChange={onChange}
              activeTab={activeTab}
              key={`${label}-tab-${index}`}
            />
          );
        })}
      </Container>
      <div>{contentToShow}</div>
    </>
  );
};

export const Tabs: React.FC<TabsProps> & {
  WithContent: typeof TabsWithContent;
} = (props) => {
  const { activeTab, className, onChange, tabs } = props;

  return (
    <Container className={className}>
      {tabs.map((tab, index) => {
        const { label, name } = typeof tab === 'string' ? { label: tab, name: tab } : tab;
        return (
          <Tab
            name={name}
            label={label || name}
            onChange={onChange}
            activeTab={activeTab}
            key={`${label}-tab-${index}`}
          />
        );
      })}
    </Container>
  );
};

Tabs.WithContent = TabsWithContent;
